import { useState, forwardRef, useCallback } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import { SnackbarContent, CustomContentProps } from 'notistack'
import Collapse from '@mui/material/Collapse'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import IconButton from '@mui/material/IconButton'
import WarningIcon from '@mui/icons-material/Warning'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const useStyles = makeStyles(() => ({
  root: {
    '@media (min-width:600px)': {
      minWidth: '344px !important'
    }
  },
  card: {
    width: '100%'
  },
  typography: {
    color: '#fff',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  actionRoot: {
    padding: '8px 8px 8px 16px',
    justifyContent: 'space-between'
  },
  icons: {
    marginLeft: 'auto',
    color: '#fff'
  },
  expand: {
    padding: '8px 8px',
    transform: 'rotate(0deg)',
    color: '#000',
    transition: 'all .2s'
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  paper: {
    backgroundColor: '#fff',
    padding: 16
  },
  checkIcon: {
    fontSize: 20,
    paddingRight: 4
  },
  button: {
    padding: 0,
    textTransform: 'none'
  }
}))

interface ReportCompleteProps extends CustomContentProps {
  bugDetails: string
}

const BugSnackbar = forwardRef<HTMLDivElement, ReportCompleteProps>((props, ref) => {
  const classes = useStyles()
  const [expanded, setExpanded] = useState(false)

  const handleExpandClick = useCallback(() => {
    setExpanded((oldExpanded) => !oldExpanded)
  }, [])

  return (
    <SnackbarContent ref={ref} className={classes.root}>
      <Card className={classes.card} style={{ backgroundColor: '#d32f2f' }}>
        <CardActions classes={{ root: classes.actionRoot }}>
          <Typography variant='body2' className={classes.typography}>
            <WarningIcon className={classes.checkIcon} />
            {props.message}
          </Typography>
          {!!props.bugDetails && (
            <div className={classes.icons}>
              <IconButton
                aria-label='Show more'
                size='small'
                className={clsx(classes.expand, {
                  [classes.expandOpen]: expanded
                })}
                onClick={handleExpandClick}
              >
                <ExpandMoreIcon sx={{ color: '#fff' }} />
              </IconButton>
            </div>
          )}
        </CardActions>
        <Collapse in={expanded} timeout='auto' unmountOnExit>
          <Paper className={classes.paper}>
            <Typography gutterBottom variant='caption' style={{ color: '#000', display: 'block' }}>
              {props.bugDetails}
            </Typography>
          </Paper>
        </Collapse>
      </Card>
    </SnackbarContent>
  )
})

BugSnackbar.displayName = 'BugSnackbar'

export default BugSnackbar
